import React, { useCallback } from 'react';

import type { UserResponse } from 'belo-js-sdk';

import type { DefaultBeloChatGenerics } from '../../../types/types';

export type OnMentionAction<
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
> = (event: React.BaseSyntheticEvent, user?: UserResponse<BeloChatGenerics>) => void;

export const useMentionsHandlers = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>(
  onMentionsHover?: OnMentionAction<BeloChatGenerics>,
  onMentionsClick?: OnMentionAction<BeloChatGenerics>,
) =>
  useCallback(
    (event: React.BaseSyntheticEvent, mentioned_users: UserResponse<BeloChatGenerics>[]) => {
      if ((!onMentionsHover && !onMentionsClick) || !(event.target instanceof HTMLElement)) {
        return;
      }

      const target = event.target;
      const textContent = target.innerHTML.replace('*', '');

      if (textContent[0] === '@') {
        const userName = textContent.replace('@', '');
        const user = mentioned_users?.find(({ id, name }) => name === userName || id === userName);

        if (
          onMentionsHover &&
          typeof onMentionsHover === 'function' &&
          event.type === 'mouseover'
        ) {
          onMentionsHover(event, user);
        }

        if (onMentionsClick && event.type === 'click' && typeof onMentionsClick === 'function') {
          onMentionsClick(event, user);
        }
      }
    },
    [onMentionsClick, onMentionsHover],
  );
